













































import { defineComponent, computed } from '@vue/composition-api';
import { FiatCurrency, CryptoCurrency } from '../lib/Constants';

export default defineComponent({
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        currency: {
            type: String as () => CryptoCurrency,
            default: CryptoCurrency.NIM,
        },
        onlyFiatCurrencies: {
            type: Boolean,
            default: false,
        },
        activeCurrency: {
            type: String as () => CryptoCurrency | 'mbtc' | FiatCurrency,
            required: true,
        },
        fiatCurrency: {
            type: String as () => FiatCurrency,
            required: true,
        },
        otherFiatCurrencies: {
            type: Array as () => FiatCurrency[] | Readonly<FiatCurrency[]>,
            required: true,
        },
        feeOption: {
            type: Boolean,
            default: true,
        },
        sendAllOption: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const ticker = computed(() => {
            if (props.activeCurrency === 'mbtc') return 'mBTC';
            return props.activeCurrency.toUpperCase();
        });

        return {
            ticker,
        };
    },
});
